import CloseIcon from 'svg/CloseIcon';
import InfoCircle from 'svg/InfoCircle';
import { ButtonText } from 'components/Button';
import Modal from 'components/modals/Modal';

const steps = [
  {
    number: '1.',
    description: 'Share',
    highlight: 'links',
    rest: ' to your other profiles that include reviews.',
  },
  {
    number: '2.',
    description: 'The Bounce team will keep you updated on the progress via email.',
  },
];

interface ReviewGuideModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

const ReviewGuideModal: React.FC<ReviewGuideModalProps> = ({ isOpen, handleClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      classNameMaxWidth="sm:max-w-2xl"
      classNameRounded="rounded-3xl"
    >
      <div className="flex flex-col">
        {/* Modal Header */}
        <div className="flex flex-row items-center justify-between border-b border-color-border-card-lightmode px-10 py-5 dark:border-color-border-card-darkmode max-sm:px-ds-lg">
          <div className="flex flex-row items-center gap-4">
            <div className="h-6 w-6">
              <InfoCircle className="h-full w-full text-color-text-lightmode-primary dark:text-color-text-darkmode-primary" />
            </div>
            <h2 className="typography-product-heading-desktop max-sm:typography-product-heading-mobile">
              Upload your reviews
            </h2>
          </div>
          <ButtonText onClick={handleClose}>
            <CloseIcon className="h-6 w-6  text-color-text-lightmode-primary dark:text-color-text-darkmode-primary max-sm:h-3.5 max-sm:w-3.5" />
          </ButtonText>
        </div>

        {/* Modal Content */}
        <div className="flex flex-col items-center px-10 py-4 pb-8 max-sm:px-ds-lg">
          <div className="flex w-full flex-col gap-6">
            {/* Introduction */}
            <p className="typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
              Importing your reviews helps you build instant trust with new clients. It shows real,
              verified feedback from people you've coached before—right on your Bounce profile. More
              reviews mean more credibility, better visibility, and a stronger chance of getting
              booked. Plus, it saves time by reusing the great feedback you already have!
            </p>

            {/* Steps */}
            <div className="flex flex-col gap-3">
              {steps.map((step, index) => (
                <div key={index} className="flex flex-row items-start gap-3">
                  <span className="typography-product-body-highlight flex-shrink-0 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                    {step.number}
                  </span>
                  <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
                    {step.description && (
                      <>
                        {step.description}{' '}
                        {step.highlight && (
                          <span className="typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                            {step.highlight}
                          </span>
                        )}
                        {step.rest}
                      </>
                    )}
                    {!step.description && step.highlight && (
                      <span className="typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                        {step.highlight}
                      </span>
                    )}
                    {!step.description && !step.highlight && step.rest}
                  </p>
                </div>
              ))}
            </div>

            {/* Visual Guide */}
            <img src="/images/coaches/review-guide.png" alt="Review Guide" />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReviewGuideModal;
